import Box from '@zenbusiness/zui/Box';
import { superstyled } from '@zenbusiness/zui/styles';

export const HomeBanners = superstyled({
  tag: Box,
  name: 'HomeBanners',
  slot: 'HomeBanners',
  styles: () => ({
    marginBlockEnd: '1.5rem',

    // An empty wrapper would still take a flex gap in Home's stack.
    '&:empty': {
      display: 'none',
    },

    '& > :first-of-type': {
      marginTop: 0,
    },
  }),
});
